import "/fonts/fonts.css"
import FlexOverlay from "./pages/Flex/FlexOverlay"
import { Provider } from "react-redux"
import Quiz from "./pages/Quiz"
import React, { useState } from "react"
import configureStore from "/src/redux/store"
import streaming from "/media/streaming.png"
import styled from "styled-components"
import { usePubSubListener } from "/src/hooks"


const Frame = styled.main`
  width: 100%;
  height: 100%;

  /* background-size: cover;
  background-image: url(${streaming}); */
  background: none;

  font-family: "The Sans", sans-serif;
  overflow: hidden;
`

const store = configureStore()

const App = () => {

  const [primaryFontName, setPrimaryFontName] = useState()
  const [secondaryFontName, setSecondaryFontName] = useState()

  const channelId = window.location.hash.slice(1)

  usePubSubListener(channelId, data => {
    if (data.skin) {
      const { skin } = data
      setPrimaryFontName(skin.primaryFont)
      setSecondaryFontName(skin.secondaryFont)
    }
  })

  return (
    <Provider store={store}>
      <Frame
        primaryFont={primaryFontName}
        secondaryFont={secondaryFontName}
      >
        {/* <link
          href={`https://fonts.googleapis.com/css?family=${primaryFontName}%7C${secondaryFontName}`}
          rel="stylesheet"
        /> */}
        <FlexOverlay />
        <Quiz />
      </Frame>
    </Provider>
  )
}

export default App
